/**
 * Routes where the mobile floating nav (Home / Create / Profile) should appear.
 * Social / posts scope only — excludes cashflow, admin panel, and marketing pages.
 */
export function isSocialMobileChromeRoute(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';

  if (path === '/notifications' || path === '/sm/all-messages' || path === '/d/profile' || path === '/search') return true;

  if (path === '/posts' || path.startsWith('/posts/')) {
    if (path === '/posts/gvalley' || path.startsWith('/posts/gvalley/')) return false;
    return true;
  }

  return false;
}
